import { Notification, Section } from "@in/component-library";
import React, { FC, useEffect, useState } from "react";
import { handleConvertDate } from "../../../utils/dateFunctions";
import { ApiException } from "../../apis/api-error";
import { useLayout } from "../../hooks/use-layout";
import { Application } from "../../models/application";
import { Labels } from "../../models/labels";
import { TasksAndServiceProspects } from "../../models/tasks-and-service-prospects";
import LoaderSmall from "../loader-small/loader-small";
import { Action, TaskCard } from "../task-card/task-card";

interface TaskModel {
  heading: string;
  tasksAndServiceProspects?: TasksAndServiceProspects[];
  error?: ApiException;
  errorMessage?: string;
  applications?: Application[];
  isLoading?: boolean;
}

export const Tasks: FC<TaskModel> = ({
  heading,
  tasksAndServiceProspects,
  error,
  errorMessage,
  applications,
  isLoading
}) => {
  const { translations, layout } = useLayout();

  const [workList, setWorkList] = useState<(Application | TasksAndServiceProspects)[]>();

  const actions = [
    {
      actionText: "Skjul oppgave",
      actionType: "DismissTask",
      iconName: "fa-light fa-eye-slash"
    }
    // {
    //   actionText: "Slett oppgave",
    //   actionType: "DeleteTask",
    //   iconName: "fa-light fa-trash",
    // },
  ] as Action[];

  const handleCalculateTimeLeft = (deadline: Date) => {
    const deadlineDate: Date = new Date(deadline);
    const currentDate = new Date();
    const timeDifference = deadlineDate.getTime() - currentDate.getTime();
    const daysLeft = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
    return daysLeft >= 0 ? daysLeft : null;
  };

  useEffect(() => {
    const webApplicationsWithStatusSparring = applications
      ? applications
          ?.filter((application) => application.notification !== null)
          .sort((a, b) => new Date(b.lastChange).valueOf() - new Date(a.lastChange).valueOf())
      : [];

    if (tasksAndServiceProspects) {
      setWorkList([...webApplicationsWithStatusSparring, ...tasksAndServiceProspects]);
    }
  }, [applications, tasksAndServiceProspects]);

  const cards = workList?.map((work) => {
    if (work && "applicationType" in work) {
      const application = work as Application;

      return (
        <TaskCard
          id={application.id}
          key={application.messageUrl}
          title={application.title}
          subTitle={application.applicationTypeDescription}
          url={application.messageUrl}
          primaryActionButtonText={translations[`notification${application.notification}`] ?? application.notification}
          category={"application"}
        />
      );
    } else {
      const task = work as TasksAndServiceProspects;

      const modifiedTags =
        task.tags &&
        task.tags.map((tag) => ({
          ...tag,
          tagId: translations[tag.tagId as keyof Labels]?.toUpperCase() ?? tag.tagId
        }));

      return (
        <TaskCard
          id={task.id}
          key={task.url}
          title={task.title}
          subTitle={
            task.category == "course" && task.subTitle
              ? `${parseInt(task.subTitle.trim()).toString()} ${translations.courseDuration}`
              : ""
          }
          completionPct={task.category == "course" ? Math.round(task.percentageCompleted) : null}
          primaryActionButtonText={translations[task.actionButtonText as keyof Labels]}
          imageUrl={task.imageUrl}
          deadline={task.deadLine && `${translations.deadlineLabel} ${handleConvertDate(task.deadLine)}`}
          tags={modifiedTags}
          //primaryAction={handlePrimary}
          url={task.url}
          timeLeftText={`${handleCalculateTimeLeft(task.deadLine)} ${translations.daysLeftLabel}`}
          actions={actions}
          closeLabel={translations.close}
          completedLabel={translations.enrollmentCompleted}
          category={task.category}
        />
      );
    }
  });

  return (
    <Section collapse>
      <h2 dangerouslySetInnerHTML={{ __html: heading }} />
      <TaskCard
        id="banking"
        title={translations.financeTitle}
        buttonIcon
        subTitle={translations.financeDescription}
        primaryActionButtonText={translations.financeButtonLabel}
        url={layout?.baseUrls.financeBaseUrl || ""}
      />
      {!isLoading ? (
        !!workList && workList.length > 0 ? (
          cards
        ) : workList?.length === 0 ? (
          <div dangerouslySetInnerHTML={{ __html: translations.customerTasksNoActiveTasks }} />
        ) : error ? (
          <Notification fullWidth type="error">
            {errorMessage}
          </Notification>
        ) : (
          <LoaderSmall />
        )
      ) : (
        <LoaderSmall />
      )}
    </Section>
  );
};
